import React, { Component } from 'react';
import LocaleStrings from 'Languages';

export default class Mobile extends Component {
  render(){
      return (
          <div className="text-center template-container" style={{color:'white',fontSize:20,padding:20,fontWeight:'bold'}}>
            {LocaleStrings.event_not_available_on_mobile}
          </div>
      );
  }
}
